import { Link } from "react-router-dom";
import "../styles/footer.css";

export default function Footer({ logo, t, language }) {
  const year = new Date().getFullYear();

  const labels = {
    en: {
      nav: "Navigation",
      services: "Services",
      about: "About",
      contact: "Contact",
      contactTitle: "Contact",
      whatsapp: "WhatsApp",
      instagram: "Instagram",
      rights: "All rights reserved.",
    },
    es: {
      nav: "Navegación",
      services: "Servicios",
      about: "Nosotros",
      contact: "Contacto",
      contactTitle: "Contacto",
      whatsapp: "WhatsApp",
      instagram: "Instagram",
      rights: "Todos los derechos reservados.",
    },
  };

  const copy = labels[language] || labels.en;

  return (
    <footer className="footer">
      <div className="footer-glow footer-glow-one"></div>
      <div className="footer-glow footer-glow-two"></div>

      <div className="footer-container">
        <div className="footer-brand">
          <Link to="/" className="footer-logo-wrap">
            <img src={logo} alt="Matneu Investment" />
          </Link>

          <p>{t.footer}</p>
        </div>

        <div className="footer-column">
          <h4>{copy.nav}</h4>

          <Link to="/#services">{copy.services}</Link>
          <Link to="/#about">{copy.about}</Link>
          <Link to="/#contact">{copy.contact}</Link>
        </div>

        <div className="footer-column">
          <h4>{copy.contactTitle}</h4>

          <a href="mailto:info@matneuinvestment.com">
            info@matneuinvestment.com
          </a>

          <a href="https://wa.me/+16893403293" target="_blank" rel="noreferrer">
            {copy.whatsapp}
          </a>

          <a href="https://instagram.com" target="_blank" rel="noreferrer">
            {copy.instagram}
          </a>
        </div>
      </div>

      <div className="footer-bottom">
        <span>© {year} Matneu Investment.</span>
        <span>{copy.rights}</span>
      </div>
    </footer>
  );
}